import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import getKhattabat102Store from "../102-stores";
import getKhattabat101MessagingStore from "./101-messaging-store";
import { fileOpen } from "browser-fs-access";
import { apiCallSendOneOOneMedia } from "../../../api/khattbat-api/api-call-send-one-o-one-media";
import {
  ALLOWED_UPLOADED_IMAGES_TYPES,
  MAX_UPLOADED_IMAGE_SIZE_IN_MB
} from "../../../constants/input-entries-constants";
import { imageHelper } from "../../../helpers/image-helper";
import { TMediaType } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import { reduce } from "et3-type-guards";
import getKhattabatSharedMessagingStore from "./conversation-messaging-store";

class KhattabatMediaStore {
  conversationID = observable.box<string>("");
  imageToBeUploadedBase64 = observable.box<string>("");

  sendMediaMessage = async ({ type }: { type: TMediaType }) => {
    const { data, status, code } = await apiCallSendOneOOneMedia({
      userID: getKhattabat101MessagingStore(
        this.conversationID.get()
      ).receiverID.get(),
      conversationID: this.conversationID.get(),
      type,
      duration: 0
    });
    if (status === "OK") {
      const mediaMessage = reduce(() => data.mideaMessage, "");
      getKhattabatSharedMessagingStore(
        this.conversationID.get()
      ).appendSentMessage({
        message: mediaMessage,
        messageType: type
      });
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
  handleImageUpload = async () => {
    const conversationType = getKhattabatSharedMessagingStore(
      this.conversationID.get()
    ).conversationType.get();
    try {
      // Open file dialog and allow the user to select an image file
      const file = await fileOpen({
        mimeTypes: ["image/*"], // Restrict to image files
        extensions: ALLOWED_UPLOADED_IMAGES_TYPES, // Common image extensions
        multiple: false
      });

      // Read the file as a Data URL (base64 encoded)
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        if (typeof reader.result === "string") {
          const initialImageSizeInMb = imageHelper.getImageFileSize(
            reader.result
          );
          let resizedImageBase64 = reader.result;
          if (initialImageSizeInMb > MAX_UPLOADED_IMAGE_SIZE_IN_MB) {
            resizedImageBase64 = await imageHelper.resizeBase64Image(
              reader.result
            );
          }
          runInAction(() => {
            this.imageToBeUploadedBase64.set(resizedImageBase64);
          });

          const isOneOTwoConversation = conversationType === "102";
          if (isOneOTwoConversation) {
            getKhattabat102Store(
              this.conversationID.get()
            ).sendOneOTwoMediaDataBase({ type: "picture" });
          } else {
            await this.sendMediaMessage({ type: "picture" });
          }
        }
      };
    } catch (error) {}
  };
}

const getKhattabatMediaStore = memoize((conversationID: string) => {
  const store = new KhattabatMediaStore();
  store.conversationID.set(conversationID);
  return store;
});

export default getKhattabatMediaStore;
